// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input.is-uppercase[data-v-4777b50e] {\n  text-transform: uppercase;\n}\ninput.is-uppercase[data-v-4777b50e]::-webkit-input-placeholder {\n  text-transform: none;\n}\ninput.is-uppercase[data-v-4777b50e]::-moz-placeholder {\n  text-transform: none;\n}\ninput.is-uppercase[data-v-4777b50e]:-moz-placeholder {\n  text-transform: none;\n}\ninput.is-uppercase[data-v-4777b50e]:-ms-input-placeholder {\n  text-transform: none;\n}\n.tile[data-v-4777b50e] {\n  min-height: 350px;\n}", ""]);
// Exports
module.exports = exports;
